import { type Control, type FieldValues, type Path, useController } from 'react-hook-form'
import { StyleSheet, View, type ViewProps } from 'react-native'
import { HelperText } from 'react-native-paper'
import DateTimePicker, { type DateTimePickerProps } from '@/components/DateTimePicker'

export type DateTimeInputProps<T extends FieldValues = Record<string, unknown>> = Omit<
    DateTimePickerProps,
    'value' | 'onChange'
> & {
    name: Path<T>
    control: Control<T>
    label: string
    hint?: string
    wrapperProps?: ViewProps
}

export function DateTimeInput<T extends FieldValues = Record<string, unknown>>({
    name,
    control,
    label,
    hint,
    wrapperProps = {},
    ...dateTimePickerProps
}: DateTimeInputProps<T>) {
    const {
        field,
        fieldState: { error },
    } = useController({
        name,
        control,
    })

    return (
        <View style={[styles.inputWrapper, wrapperProps.style]} {...wrapperProps}>
            <DateTimePicker
                {...dateTimePickerProps}
                value={field.value}
                onChange={field.onChange}
                label={label}
                error={!!error}
            />
            {hint && !error ? <HelperText type="info">{hint}</HelperText> : null}
            {error ? <HelperText type="error">{error.message}</HelperText> : null}
        </View>
    )
}

const styles = StyleSheet.create({
    inputWrapper: {
        marginBottom: 8,
    },
})
